var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGoogleDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36082 17.7835L5.15464 19.1546C5.31959 19.4433 5.5567 19.6701 5.83505 19.8351L8.6701 14.9278H3C3 15.2474 3.08247 15.567 3.24742 15.8557L4.36082 17.7835Z",
    fill: "#0066DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.15464L9.16495 4.24742C8.8866 4.41237 8.64948 4.63918 8.48454 4.92783L3.24742 14C3.08551 14.2824 3.00022 14.6023 3 14.9278H8.6701L12 9.15464Z",
    fill: "#00AC47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1649 19.8351C18.4433 19.6701 18.6804 19.4433 18.8454 19.1546L19.1753 18.5876L20.7526 15.8557C20.9175 15.567 21 15.2474 21 14.9278H15.3295L16.5361 17.299L18.1649 19.8351Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.15464L14.8351 4.24742C14.5567 4.08247 14.2371 4 13.9072 4H10.0928C9.76289 4 9.4433 4.09278 9.16495 4.24742L12 9.15464Z",
    fill: "#00832D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3295 14.9278H8.6701L5.83505 19.8351C6.1134 20 6.43299 20.0825 6.76289 20.0825H17.2371C17.567 20.0825 17.8866 19.9897 18.1649 19.8351L15.3295 14.9278Z",
    fill: "#2684FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.134 9.46392L15.5155 4.92783C15.3505 4.63918 15.1134 4.41237 14.8351 4.24742L12 9.15464L15.3295 14.9278H20.9897C20.9897 14.6082 20.9072 14.2887 20.7423 14L18.134 9.46392Z",
    fill: "#FFBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogleDrive);
export default __webpack_public_path__ + "static/media/Logo_GoogleDrive.663f43f1a03532b05aa96c76e5c7c7cc.svg";
export { ForwardRef as ReactComponent };